export const UserPermissions={
    add_note:"add_note",
    pickUp:"pickUp",
    delete_pick:"delete_pick",
    updateCallingStatus:"updateCallingStatus",
    replace:"replace",
    update_cache:"update_cache"

}